import { CalendarStyles as fastCalendarStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationCalendarStyles = () => css `
  ${fastCalendarStyles}
`;
